/* CertiClear global scripts — loaded on every page from layout/theme.liquid.
   Scope: mobile nav, quantity steppers, the AJAX cart (window.CertiClearCart),
   section swapping, the cart drawer, the reorder button and the sticky bar's
   show/hide. Product-only behaviour lives in assets/product.js (loaded by
   sections/main-product.liquid); predictive search lives in assets/search.js
   (loaded by sections/header.liquid); the dosage calculator lives in
   assets/calculator.js (loaded by sections/dosage-calculator.liquid). */

(function () {
  'use strict';

  /* Mobile navigation toggle */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;
    var isOpen = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  /* Quantity steppers */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quantity-change]');
    if (!button) return;
    var wrapper = button.closest('.quantity-input');
    var input = wrapper && wrapper.querySelector('input');
    if (!input || input.disabled) return;
    var step = parseInt(button.getAttribute('data-quantity-change'), 10);
    var min = parseInt(input.min || '1', 10);
    var value = parseInt(input.value || '1', 10) + step;
    input.value = Math.max(min, value);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Add-to-cart button state machine ---------------- */

  /* ONE implementation of adding… / Added ✓ / error, shared by every add
     path (product form, quick-add card, reorder). `run` returns the promise
     so the button is already in its "adding" state when the request starts. */
  function withAddButton(button, run) {
    var originalText = button ? button.textContent : '';
    if (button) {
      if (button._cartFeedbackTimer) clearTimeout(button._cartFeedbackTimer);
      button.removeAttribute('data-cart-feedback');
      button.setAttribute('data-cart-pending', '');
      button.disabled = true;
      button.textContent = button.getAttribute('data-adding-text') || 'Adding…';
    }
    return run()
      .then(function (result) {
        if (button) {
          button.setAttribute('data-cart-feedback', '');
          button.textContent = button.getAttribute('data-added-text') || 'Added ✓';
        }
        return result;
      })
      .catch(function (err) {
        if (button) {
          button.setAttribute('data-cart-feedback', '');
          button.textContent = (err && err.description) || 'Could not confirm. Check your cart before retrying.';
        }
      })
      .finally(function () {
        if (button) {
          button.removeAttribute('data-cart-pending');
          button.disabled = false;
          button._cartFeedbackTimer = setTimeout(function () {
            button.removeAttribute('data-cart-feedback');
            button.textContent = originalText;
            document.dispatchEvent(new CustomEvent('purchase:idle'));
          }, 2500);
          document.dispatchEvent(new CustomEvent('purchase:idle'));
        }
      });
  }

  /* Same reset timing as withAddButton, for messages that never hit the network */
  function flashButton(button, text) {
    if (!button) return;
    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = text;
    setTimeout(function () {
      button.disabled = false;
      button.textContent = originalText;
    }, 2500);
  }

  /* ---------------- AJAX cart ---------------- */

  function updateCartCount(count) {
    if (typeof count !== 'number' || !isFinite(count)) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function currentCartCount() {
    var el = document.querySelector('[data-cart-count]');
    var n = el ? parseInt(el.textContent, 10) : NaN;
    return isFinite(n) ? n : 0;
  }

  /* True once the drawer body in the DOM has been re-rendered from a cart
     mutation, i.e. its markup (and its [data-cart-count-src] hook) is current. */
  var drawerFresh = false;
  /* Whether the last mutation already swapped its surface(s) in place. */
  var lastMutationSwapped = false;

  /* Which section the cart mutation endpoints should render for us: the drawer
     everywhere it exists, the cart page section on /cart (no drawer there). */
  function cartSectionId() {
    var ids = [];
    if (document.querySelector('[data-cart-drawer]')) ids.push('cart-drawer');
    var root = document.querySelector('[data-cart-page-root]');
    if (root) ids.push(root.getAttribute('data-section-id') || 'main');
    return ids.length ? ids : null;
  }

  /* Swap the innerHTML of `selector` with the matching node from freshly
     rendered section HTML — no full page reload. */
  function swapSectionHTML(html, selector) {
    if (typeof html !== 'string' || !html) return false;
    var parsed = document.createElement('div');
    parsed.innerHTML = html;
    var incoming = parsed.querySelector(selector);
    var current = document.querySelector(selector);
    if (!incoming || !current) return false;
    current.innerHTML = incoming.innerHTML;
    return true;
  }

  /* Apply the `sections` payload Shopify returns alongside /cart/add.js and
     /cart/change.js — the whole drawer body (items, incentives, upsell,
     subtotal, checkout buttons) and/or the cart page re-render for free. */
  function applySections(sections) {
    if (!sections) return false;
    var complete = true;
    var present = false;
    if (document.querySelector('[data-cart-drawer]')) {
      present = true;
      drawerFresh = swapSectionHTML(sections['cart-drawer'], '[data-cart-drawer-body]');
      complete = drawerFresh;
    }
    var root = document.querySelector('[data-cart-page-root]');
    var pageId = root && (root.getAttribute('data-section-id') || 'main');
    if (pageId) {
      present = true;
      if (!swapSectionHTML(sections[pageId], '[data-cart-page-root]')) complete = false;
    }
    return present && complete;
  }

  /* The freshly rendered drawer carries the new item count as an attribute, so
     adding to cart never needs a second /cart.js round trip just to read it. */
  function renderedCartCount() {
    if (!drawerFresh) return null;
    var el = document.querySelector('[data-cart-count-src]');
    if (!el) return null;
    var n = parseInt(el.getAttribute('data-cart-count-src'), 10);
    return isFinite(n) ? n : null;
  }

  /* /cart/add.js answers with the added line(s), not the whole cart. Build the
     detail object listeners (Klaviyo bridge, analytics) expect from it plus the
     item count the re-rendered drawer just told us. */
  function addedCartDetail(data, items) {
    var detail = {};
    Object.keys(data || {}).forEach(function (key) {
      if (key !== 'sections') detail[key] = data[key];
    });
    if (!detail.items) detail.items = (data && data.id) ? [data] : items;
    var count = renderedCartCount();
    if (count == null) {
      count = currentCartCount();
      items.forEach(function (item) { count += parseInt(item.quantity, 10) || 0; });
    }
    detail.item_count = count;
    return detail;
  }

  function cartURL(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || '/') + path;
  }

  function readJSON(response) {
    return response.json().catch(function () { return null; }).then(function (data) {
      if (!response.ok || !data) {
        var err = new Error('Could not confirm the cart change. Check your cart before trying again.');
        err.description = err.message;
        err.status = response.status;
        throw err;
      }
      return data;
    });
  }

  // Bound fetch and response-body consumption. Aborting a write cannot prove
  // that Shopify did not accept it; never retry it automatically.
  function requestTimeoutMs() {
    var config = window.CertiClearCartConfig || {};
    var value = Number(config.requestTimeoutMs);
    if (!isFinite(value) || value <= 0) value = 10000;
    return Math.min(30000, Math.max(1000, value));
  }

  function requestJSON(url, options, reader, remainingMs) {
    var init = Object.assign({}, options || {});
    var isWrite = (init.method || 'GET').toUpperCase() !== 'GET';
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    if (controller) init.signal = controller.signal;
    var timeout = requestTimeoutMs();
    if (remainingMs !== undefined) timeout = Math.max(1, Math.min(timeout, remainingMs));
    return new Promise(function (resolve, reject) {
      var settled = false;
      var status = 0;
      function fail(cause) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        var err = cause && typeof cause === 'object' ? cause : new Error('Request failed.');
        err.status = typeof err.status === 'number' ? err.status : status;
        err.uncertain = isWrite && (!err.status || (err.status >= 200 && err.status < 300) || err.status >= 500);
        if (!err.description) err.description = err.uncertain
          ? 'Could not confirm the change. Check your cart before trying again.'
          : 'The request could not be completed. Confirm details at checkout.';
        reject(err);
      }
      var timer = setTimeout(function () {
        var err = new Error('Request timed out.');
        err.code = 'REQUEST_TIMEOUT';
        fail(err);
        if (controller) controller.abort();
      }, timeout);
      Promise.resolve().then(function () {
        return fetch(url, init);
      }).then(function (response) {
        if (settled) return null;
        status = response.status;
        return (reader || readJSON)(response);
      }).then(function (data) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve(data);
      }, fail);
    });
  }

  var cartQueue = Promise.resolve();

  // A failed request does not poison the queue or retry a possibly accepted add.
  function enqueueCart(run) {
    var result = cartQueue.then(run);
    cartQueue = result.catch(function () {});
    return result;
  }

  function reconcileCart() {
    drawerFresh = false;
    return Promise.allSettled([
      requestJSON(cartURL('cart.js')).then(function (cart) { updateCartCount(cart.item_count); }),
      refreshCartDrawer(),
      refreshCartPage()
    ]); // Wait for every read: a late old response must not race the next write.
  }

  function mutateCart(operation, body, isAdd) {
    return enqueueCart(function () {
      var sectionIds = cartSectionId();
      if (sectionIds) {
        body.sections = sectionIds;
        body.sections_url = window.location.pathname;
      }
      drawerFresh = false;
      lastMutationSwapped = false;
      return requestJSON(cartURL('cart/' + operation + '.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (data) {
        lastMutationSwapped = applySections(data.sections);
        var renderPending = false;
        var refresh = lastMutationSwapped ? Promise.resolve() : Promise.allSettled([refreshCartDrawer(), refreshCartPage()]).then(function (results) {
          // The POST already succeeded. A rendering failure must never invite
          // the customer to repeat that successful commercial action.
          var drawerRequired = !!document.querySelector('[data-cart-drawer]');
          var pageRequired = !!document.querySelector('[data-cart-page-root]');
          renderPending = (drawerRequired && (results[0].status !== 'fulfilled' || !results[0].value)) ||
            (pageRequired && (results[1].status !== 'fulfilled' || !results[1].value));
          if (renderPending) document.dispatchEvent(new CustomEvent('cart:render-error', { detail: { operation: operation } }));
        });
        return refresh.then(function () {
          var detail = isAdd ? addedCartDetail(data, body.items) : Object.keys(data).reduce(function (copy, key) {
            if (key !== 'sections') copy[key] = data[key];
            return copy;
          }, {});
          if (renderPending) detail.render_pending = true;
          updateCartCount(detail.item_count);
          document.dispatchEvent(new CustomEvent(isAdd ? 'cart:added' : 'cart:updated', { detail: detail }));
          return detail;
        });
      }).catch(function (err) {
        document.dispatchEvent(new CustomEvent('cart:error', {
          detail: { operation: operation, status: (err && err.status) || 0,
            uncertain: !!(err && err.uncertain), code: (err && err.code) || 'REQUEST_FAILED' }
        }));
        return reconcileCart().then(function () { throw err; });
      });
    });
  }

  function changeByKey(key, quantity, plan) {
    if (typeof key !== 'string' || key.indexOf(':') < 1 || !Number.isInteger(quantity) || quantity < 0) {
      return Promise.reject(new Error('Refresh the cart before changing this item.'));
    }
    var body = { id: key, quantity: quantity };
    if (plan !== undefined) body.selling_plan = plan;
    return mutateCart('change', body, false);
  }

  window.CertiClearCart = {
    /* ONE request per add: Shopify returns the rendered section HTML in the
       same response as the mutation (sections + sections_url). */
    add: function (items) {
      return mutateCart('add', { items: items }, true);
    },
    update: function (updates) {
      return mutateCart('update', { updates: updates }, false);
    },
    /* Change a single line by its 1-based line number (Shopify /cart/change.js).
       `line` is the position in the cart, NOT a variant id. The response carries
       the full cart AND the re-rendered section, so quantity edits and removals
       are one request too. */
    change: function (key, quantity) {
      return changeByKey(key, quantity);
    },
    /* Convert an existing one-time line into a subscription IN PLACE: same line,
       same quantity, now carrying a selling plan. One request — the response
       brings the re-rendered surface with it, exactly like change(). Rejects on
       a non-2xx so the caller can restore its button and leave the line alone. */
    changePlan: function (key, quantity, sellingPlan) {
      return changeByKey(key, quantity, sellingPlan);
    },
    // Quotes are read-only and describe the current cart, never a temporary SKU.
    estimateShipping: function (zip) {
      if (!/^\d{5}(-\d{4})?$/.test(zip)) return Promise.reject(new Error('Enter a valid US ZIP code.'));
      return enqueueCart(function () {
        var deadline = Date.now() + requestTimeoutMs();
        return requestJSON(cartURL('cart.js')).then(function (cart) {
          if (!cart.item_count) return { requires_items: true, shipping_rates: [] };
          var url = cartURL('cart/shipping_rates.json') + '?shipping_address[zip]=' + encodeURIComponent(zip) +
            '&shipping_address[country]=United%20States';
          function rates(attempt) {
            if (Date.now() >= deadline) throw new Error('Rates timed out. Confirm delivery at checkout.');
            return requestJSON(url, undefined, function (response) {
              return response.status === 202 ? null : readJSON(response);
            }, deadline - Date.now()).then(function (data) {
              if (data === null) {
                if (attempt >= 6) throw new Error('Rates are not ready. Confirm delivery at checkout.');
                return new Promise(function (resolve) { setTimeout(resolve, Math.max(1, Math.min(500, deadline - Date.now()))); }).then(function () { return rates(attempt + 1); });
              }
              return data;
            });
          }
          return rates(0);
        });
      }).catch(function (err) {
        // A quote is read-only. Do not reuse mutation recovery wording here.
        err.description = 'Could not estimate delivery rates for this cart and ZIP. Confirm delivery at checkout. No items were added or removed by this estimate.';
        throw err;
      });
    }
  };

  /* Section Rendering API: pull one section's fresh HTML for the current URL.
     Fallback path only — mutations render their sections inline. */
  function fetchSectionHTML(sectionId) {
    var url = window.location.pathname + '?sections=' + encodeURIComponent(sectionId);
    return requestJSON(url, { headers: { 'Accept': 'application/json' } })
      .then(function (data) { return data ? data[sectionId] : null; });
  }

  function swapSection(sectionId, selector) {
    return fetchSectionHTML(sectionId).then(function (html) {
      return swapSectionHTML(html, selector);
    });
  }

  function refreshCartPage() {
    var root = document.querySelector('[data-cart-page-root]');
    if (!root) return Promise.resolve(false);
    var id = root.getAttribute('data-section-id') || 'main';
    return swapSection(id, '[data-cart-page-root]');
  }

  function refreshCartDrawer() {
    if (!document.querySelector('[data-cart-drawer]')) return Promise.resolve(false);
    return swapSection('cart-drawer', '[data-cart-drawer-body]').then(function (swapped) {
      if (swapped) drawerFresh = true;
      return swapped;
    });
  }

  /* Collect enabled properties[Key] fields from a form into a { Key: value }
     object for /cart/add.js. Disabled inputs (e.g. pickup props while shipping
     is selected) are skipped, as are unchecked checkboxes/radios. */
  function serializeProperties(form) {
    var fields = form.querySelectorAll('[name^="properties["]');
    var props = null;
    fields.forEach(function (field) {
      if (field.disabled) return;
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
      var match = field.getAttribute('name').match(/^properties\[(.+)\]$/);
      if (!match) return;
      props = props || {};
      props[match[1]] = field.value;
    });
    return props;
  }

  /* Product forms: intercept submit and add via AJAX */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-ajax-cart]');
    if (!form) return;
    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    if (button && button.hasAttribute('data-cart-pending')) return;
    if (form.getAttribute('data-offer-error')) { flashButton(button, 'Choose an available purchase option.'); return; }

    var idField = form.querySelector('[name="id"]');
    var qtyField = form.querySelector('[name="quantity"]');
    var planField = form.querySelector('[name="selling_plan"]');
    var item = {
      id: parseInt(idField.value, 10),
      quantity: qtyField ? parseInt(qtyField.value, 10) || 1 : 1
    };
    if (form.getAttribute('data-purchase-ready') === 'false') {
      flashButton(button, 'Purchase options are still loading. Please reload.'); return;
    }
    var purchaseOption = form.querySelector('[data-selling-plan-toggle]:checked');
    var hasPurchaseControls = form.querySelector('[data-selling-plan-toggle]') || form.hasAttribute('data-product-purchase');
    var oneTimeOnly = form.getAttribute('data-purchase-mode') === 'one-time';
    var requiredOffer = form.hasAttribute('data-subscription-offer') || form.getAttribute('data-requires-selling-plan') === 'true';
    if (hasPurchaseControls && !purchaseOption && !oneTimeOnly) {
      flashButton(button, 'Choose a purchase type before adding.'); return;
    }
    // A hidden field inserted by an app is never positive subscription intent.
    var explicitOneTime = oneTimeOnly || (purchaseOption && purchaseOption.value === '') || (!purchaseOption && !requiredOffer);
    if (explicitOneTime && requiredOffer) {
      flashButton(button, 'Choose an available subscription option.'); return;
    }
    var requiresPlan = !explicitOneTime && (requiredOffer || (purchaseOption && purchaseOption.value !== ''));
    if (requiresPlan && planField && !planField.disabled) {
      /* Accept numeric ids AND Shopify GIDs (gid://shopify/SellingPlan/123) —
         parseInt on a GID yields NaN, which JSON.stringify drops silently and
         the item would be added one-time at full price */
      var planMatch = String(planField.value || '').match(/^(?:gid:\/\/shopify\/SellingPlan\/)?([1-9]\d*)$/);
      if (!planMatch) { flashButton(button, 'Choose an available subscription option.'); return; }
      item.selling_plan = Number(planMatch[1]);
    }
    if (requiresPlan && !item.selling_plan) { flashButton(button, 'Choose an available subscription option.'); return; }
    var fixedPlan = form.getAttribute('data-subscription-plan');
    if (requiresPlan && fixedPlan && String(item.selling_plan) !== fixedPlan) {
      flashButton(button, 'Subscription option changed. Review it before adding.'); return;
    }
    // App scripts can rewrite their hidden input after the theme's capture
    // handler. Never charge a plan different from the shopper's visible choice.
    var planSelect = form.querySelector('[data-selling-plan-select]');
    if (requiresPlan && planSelect && (planSelect.disabled || String(item.selling_plan) !== String(planSelect.value))) {
      flashButton(button, 'Purchase option changed. Select it again before adding.'); return;
    }
    var properties = serializeProperties(form);
    if (properties) item.properties = properties;
    var items = [item];

    withAddButton(button, function () { return window.CertiClearCart.add(items); });
  });

  /* Cart line changes (cart page + drawer share the same data hooks).
     Re-render the affected surface via the Section Rendering API — no reload. */
  function refreshCartSurface(node) {
    return node && node.closest('[data-cart-drawer]') ? refreshCartDrawer() : refreshCartPage();
  }
  // Prevent a second control from using the previous line's quantity or key.
  var pendingCartLines = new Set();

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-line-qty]');
    if (!input) return;
    var line = input.getAttribute('data-cart-line-key');
    if (!line || pendingCartLines.has(line)) return;
    pendingCartLines.add(line);
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    input.disabled = true;
    window.CertiClearCart.change(line, qty).then(function () {
      /* The change response already re-rendered the surface in place */
      return lastMutationSwapped ? true : refreshCartSurface(input);
    }).then(function (swapped) {
      if (!swapped) input.disabled = false;
    }).catch(function () {
      input.disabled = false;
    }).finally(function () { pendingCartLines.delete(line); });
  });

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-line-remove]');
    if (!remove) return;
    event.preventDefault();
    var line = remove.getAttribute('data-cart-line-key');
    if (!line || pendingCartLines.has(line)) return;
    pendingCartLines.add(line);
    window.CertiClearCart.change(line, 0).then(function () {
      if (lastMutationSwapped) return true;
      return refreshCartSurface(remove);
    }).catch(function () { flashButton(remove, 'Could not confirm removal. Check your cart.'); })
      .finally(function () { pendingCartLines.delete(line); });
  });

  /* Per-line "Switch to Subscribe & Save": convert a one-time line to the
     cheapest selling plan without leaving the drawer / cart page. The prices in
     the label were rendered from the live allocation, so nothing is promised
     here that the cart cannot honor. On failure the label is restored and the
     line stays exactly as it was. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-line-plan]');
    if (!button) return;
    event.preventDefault();

    var line = button.getAttribute('data-cart-line-key');
    var plan = parseInt(String(button.getAttribute('data-selling-plan') || '').replace(/\D/g, ''), 10);
    var quantity = parseInt(button.getAttribute('data-quantity'), 10) || 1;
    if (!line || !(plan > 0) || pendingCartLines.has(line)) return;
    pendingCartLines.add(line);

    var label = button.querySelector('.cart-line-plan__label') || button;
    var originalText = label.textContent;
    button.disabled = true;
    button.classList.add('is-switching');
    label.textContent = button.getAttribute('data-switching-text') || 'Switching…';

    window.CertiClearCart.changePlan(line, quantity, plan).then(function () {
      /* The change response already re-rendered the surface in place */
      return lastMutationSwapped ? true : refreshCartSurface(button);
    }).then(function () {
      /* The button is usually gone with the swap; harmless when it is not */
      button.classList.remove('is-switching');
      label.textContent = button.getAttribute('data-switched-text') || 'Subscription applied ✓';
    }).catch(function () {
      button.disabled = false;
      button.classList.remove('is-switching');
      label.textContent = originalText;
    }).finally(function () { pendingCartLines.delete(line); });
  });

  /* ---------------- Cart drawer ---------------- */

  function getDrawer() { return document.querySelector('[data-cart-drawer]'); }

  /* `skipRefresh` (a.k.a. alreadyFresh): the caller already has current drawer
     markup — from the sections payload of the add/change request — so opening
     costs zero extra network round trips. */
  function openCartDrawer(skipRefresh) {
    var drawer = getDrawer();
    if (!drawer) return;
    function show() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      var close = drawer.querySelector('[data-cart-drawer-close]');
      if (close) close.focus();
    }
    if (skipRefresh) {
      show();
      return;
    }
    refreshCartDrawer().then(show, show);
  }

  function closeCartDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  /* Open automatically whenever something lands in the cart. The add response
     already carried the rendered drawer, so this is instant — only fall back to
     a fetch when that markup did not arrive. */
  document.addEventListener('cart:added', function (event) {
    if (event.detail && event.detail.render_pending) { window.location.href = cartURL('cart'); return; }
    openCartDrawer(drawerFresh);
  });

  /* Keep an already-open drawer in sync with any other cart mutation */
  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.render_pending) { window.location.href = cartURL('cart'); return; }
    var drawer = getDrawer();
    if (drawer && drawer.classList.contains('is-open') && !drawerFresh) refreshCartDrawer().catch(function () {});
  });

  /* Header cart icon: keep href="/cart" working without JS, open the drawer with it */
  document.addEventListener('click', function (event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var trigger = event.target.closest('[data-cart-drawer-toggle]');
    if (!trigger) return;
    if (!getDrawer()) return; /* cart page — let the link through */
    event.preventDefault();
    openCartDrawer(drawerFresh);
  });

  /* Close: X button, overlay click, Esc */
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-close]') || event.target.closest('[data-cart-drawer-overlay]')) {
      event.preventDefault();
      closeCartDrawer();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    var drawer = getDrawer();
    if (drawer && drawer.classList.contains('is-open')) closeCartDrawer();
  });

  /* ---------------- Reorder a whole past order (account page) ---------------- */

  /* A reorder is a new one-time purchase. Never recreate a historical contract
     or copy stale pickup instructions/profile properties from an old order. */
  function parseReorderItems(button) {
    var raw = button.getAttribute('data-reorder-items');
    var parsed;
    try {
      parsed = JSON.parse(raw || '[]');
    } catch (e) {
      parsed = [];
    }
    if (!Array.isArray(parsed)) return [];
    return parsed.reduce(function (items, entry) {
      var id = entry && parseInt(entry.id, 10);
      var quantity = entry && parseInt(entry.quantity, 10);
      if (!id || !(quantity > 0)) return items;
      var item = { id: id, quantity: quantity };
      items.push(item);
      return items;
    }, []);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-reorder]');
    if (!button) return;
    event.preventDefault();

    var items = parseReorderItems(button);

    if (!items.length) {
      flashButton(button, button.getAttribute('data-empty-text') || 'Nothing to reorder');
      return;
    }

    /* One request, quantities preserved, explicitly no subscription plan. */
    withAddButton(button, function () { return window.CertiClearCart.add(items); });
  });

  /* Sticky buy bar: slide in once the header leaves the viewport.
     While visible, pad the body so the bar never covers page-bottom content.
     The bar renders on every template, so its visibility lives here; the
     product-form proxies live in assets/product.js. */
  (function () {
    var bar = document.querySelector('[data-sticky-buy]');
    var header = document.querySelector('.site-header');
    if (!bar || !header || !('IntersectionObserver' in window)) return;
    function setBodyPadding(visible) {
      document.body.style.paddingBottom = visible ? bar.offsetHeight + 'px' : '';
    }
    new IntersectionObserver(function (entries) {
      var visible = !entries[0].isIntersecting;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      setBodyPadding(visible);
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(header);
  })();
})();
